/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForFinOpsAiOntologySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForFinOpsAiOntologySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForFinOpsAiOntologySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForFinOpsAiOntologySync>): BackgroundJobPayloadForFinOpsAiOntologySync {
        let obj = Object.assign(new BackgroundJobPayloadForFinOpsAiOntologySync(), model);
        BackgroundJobPayloadForFinOpsAiOntologySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForFinOpsAiOntologySync>): BackgroundJobPayloadForFinOpsAiOntologySync {
        if (!model) return null;
        return BackgroundJobPayloadForFinOpsAiOntologySync.newInstance(<BackgroundJobPayloadForFinOpsAiOntologySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForFinOpsAiOntologySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForFinOpsAiOntologySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForFinOpsAiOntologySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForFinOpsAiOntologySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack tenant whose data is being projected (named-graph scope).
     */
    tenant_id: string;

    /**
     * CoreStack master account (GraphDB repo scope).
     */
    master_account_id: string;

    /**
     * Cloud account whose AI inventory / cost / telemetry is being projected.
     */
    service_account_id: string;

    /**
     * Which ontology family to project. inventory: AIResource. cost: AIBillingClassification + AIMonthlyCost. utilization: AIUtilizationMetric + AIUtilizationMonth. activity: AIActivitySummary. prompt: AIPromptPattern + usage months + recommendations.
     */
    family: models.FinOpsAiOntologySyncFamily;

}
